import axios from "axios";

import { config, data } from "~/data";

export async function fetchSocialShareCount(relativeUrl: string) {
  const resp = await axios.get<Response>(config.social.api.host, {
    params: { url: `https://${data.scmpDomains.SCMP}${relativeUrl}` },
  });
  return resp.data.total;

  type Response = {
    total: number;
  };
}
